import React from 'react';
import ContentLoader from 'react-content-loader';

const FacetsLoader = () => {
  return (
    <ContentLoader
      speed={2}
      width={270}
      height={114}
      viewBox={`0 0 270 114`}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb">
      <rect x="0" y="0" rx="6" ry="6" width="270" height="114" />
    </ContentLoader>
  );
};

export default FacetsLoader;
